export default __webpack_public_path__ + "static/media/bg.6ae12a81.svg";